import { render, staticRenderFns } from "./OnboardingDocuments.vue?vue&type=template&id=4c15f992&"
import script from "./OnboardingDocuments.vue?vue&type=script&lang=js&"
export * from "./OnboardingDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front.sfc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports